import React from "react";
import { Link } from "react-router-dom";
import useFetchApiData from "../helper/useFetchApiData";

const PromotionalOne = () => {
  const secBanner = useFetchApiData("/banners");

  // Only render the section if secBanner contains data
  if (!secBanner || secBanner.length === 0) {
    return <></>; // Return null or empty if no banners
  }

  return (
    <section className="promotional-banner pt-80">
      <div className="container container-lg">
        <div className="row gy-4">
          {secBanner
            .filter((item) => item.banner_type === "secondary") // Filter secondary banners
            .map((banner) => (
              <div className="col-xl-3 col-sm-6 col-xs-6" key={banner.id}>
                <div className="promotional-banner-item position-relative rounded-24 overflow-hidden z-1">
                  <img
                    src={banner.image_fullpath}
                    alt={banner.title}
                    className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 object-fit-cover z-n1"
                    style={{ filter: "brightness(40%)" }}
                  />
                  <div className="promotional-banner-item__content">
                    <h6 className="promotional-banner-item__title text-32 text-white">
                      {banner.title}
                    </h6>
                    {banner.category_id ? (
                      <Link
                        to={`/shop/${banner.category_id}`}
                        className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8 mt-24"
                      >
                        Shop Now
                        <span className="icon text-xl d-flex">
                          <i className="ph ph-arrow-right" />
                        </span>
                      </Link>
                    ) : (
                      <Link
                        to={`product/${banner.product_id}`}
                        className="btn btn-main d-inline-flex align-items-center rounded-pill gap-8 mt-24"
                      >
                        Shop Now
                        <span className="icon text-xl d-flex">
                          <i className="ph ph-arrow-right" />
                        </span>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default PromotionalOne;
